import LeafletMouseControl from "./LeafletMousePosition";
import { MapControl, withLeaflet } from "react-leaflet";
import type { MapControlProps } from "react-leaflet";

type LeafletElement = LeafletWatermarkControl;

type Props = {
  position?: string,
  separator?: string,
  lngFirst?: boolean,
  numDigits?: number,
  prefix?: string,
} & MapControlProps;

class MouseControl extends MapControl<LeafletElement, Props> {
  static defaultProps = {
    position: true,
  };

  createLeafletElement(props: Props): LeafletElement {
    return new LeafletMouseControl(props);
  }
}

export default withLeaflet(MouseControl);
